import { createContext } from 'react';
export var TranslationContext = createContext({
    locale: 'en',
    translate: function (id) { return id; },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/i18n/TranslationContext.js
// module id = 771
// module chunks = 0